<template>
    <component
        :is="element"
        v-bind="attributes"
        @click="click"
        class="base-btn"
    >
        <slot></slot>
    </component>
</template>

<script>
import Navigation from "@/services/navigation";

export default {
    props: {
        route: Object,
        href: String
    },

    computed: {
        element() {
            return this.href ? 'a' : 'button';
        },

        attributes() {
            if (this.href) {
                return {
                    href: this.href
                };
            }

            return {};
        }
    },

    methods: {
        click() {
            if (this.route) {
                Navigation.push(this.route);
            }
        }
    }
}
</script>

<style>
.base-btn {
    @apply block w-full h-13 px-7 focus:outline-none border;
    width: fit-content;
    letter-spacing: 0.7px;
}
</style>
